<div class="container-fluid">
  <div class="row">
    <table id="tblInstructions" class="nj-table nj-table--hover nj-table--striped nj-cursor">
      <thead>
        <tr [style]="'background-color: #d8d8d8'" class="pointer">
          <th (click)="DataGridHelper.SortData('notifiedOn')">Notified On</th>
          @if (Asset != Assets.Retail) { <th (click)="DataGridHelper.SortData('units')">Units</th> }
          <th (click)="DataGridHelper.SortData('startDate')">Start Date</th>
          <th (click)="DataGridHelper.SortData('endDate')">End Date</th>
          <th (click)="DataGridHelper.SortData('summary')">Summary</th>
          <th (click)="DataGridHelper.SortData('reporter')">Reporter</th>
          <th (click)="DataGridHelper.SortData('status')">Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for(instruction of DataGridHelper.CurrentPageData; track instruction.instructionId; let i = $index) {
        <tr [class]="GetClass(instruction.startDate, instruction.endDate)">
          <td>{{DateFormatHelper.GetDisplayDate(instruction.notifiedOn)}}</td>
          @if (Asset != Assets.Retail) { <td>{{instruction.units}}</td> }
          <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.startDate)}}</td>
          <td>{{instruction.endDate == null ? "" : DateFormatHelper.GetDisplayDateOnly(instruction.endDate)}}</td>
          <td>{{instruction.summary}}</td>
          <td>{{instruction.reporter}}</td>
          <td>{{instruction.status}}{{instruction.isArchived ? " - Archived" : "" }}</td>
          <td>
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
              (buttonClick)="ViewInstruction(instruction.instructionId)">
              View
            </nj-button>
            @if(!UserData.IsReadOnly)
            {
              &nbsp;
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="CopyToNew(instruction.instructionId)">
                Copy
              </nj-button>
            }
          </td>
        </tr>
      }
      </tbody>
    </table>
    <nj-pagination
      [count]="DataGridHelper.PageCount" 
      [shouldMinify]="true" (selectedItem)="DataGridHelper.ChangePage($event)"></nj-pagination>
  </div>
</div>